import { faFolder } from "@fortawesome/pro-solid-svg-icons";
import { useTheme } from "@mui/material/styles";

import { Icon } from "@/components/ui-v2";

import { TileBase, TileBaseProps } from "../TileBase/TileBase";

export const DirectoryTile = (props: TileBaseProps) => {
  const theme = useTheme();

  return (
    <TileBase sx={{ background: theme.palette.secondary[6] }} {...props}>
      <Icon icon={faFolder} style={{ width: 64, height: 64 }} />
    </TileBase>
  );
};
